import { PageButton, PageButtonArrow, PaginationWrapper } from './styles';

type PaginationProps = {
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
};

export const NewPagination = ({ totalPages, currentPage, onPageChange }: PaginationProps) => {
  const goToPage = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const renderPageNumbers = () => {
    const pages: (number | string)[] = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else if (currentPage <= 4) {
      pages.push(1, 2, 3, 4, 5, '...', totalPages);
    } else if (currentPage >= totalPages - 3) {
      pages.push(1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
    } else {
      pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
    }

    return pages.map((page, idx) => (
      typeof page === 'number' ? (
        <PageButton
          style={{ minWidth: '30px', maxWidth: '100px', width: 'auto' }}
          key={idx}
          active={currentPage === page}
          onClick={() => goToPage(page)}
        >
          {page}
        </PageButton>
      ) : (
        <span key={idx} style={{ minWidth: 32, textAlign: 'center' }}>...</span>
      )
    ));
  };

  return (
    <PaginationWrapper>
      <PageButtonArrow onClick={() => goToPage(1)} disabled={currentPage === 1}>«</PageButtonArrow>
      <PageButtonArrow onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1}>‹</PageButtonArrow>

      {renderPageNumbers()}

      <PageButtonArrow onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages}>›</PageButtonArrow>
      <PageButtonArrow onClick={() => goToPage(totalPages)} disabled={currentPage === totalPages}>»</PageButtonArrow>
    </PaginationWrapper>
  );
};
